import { render, staticRenderFns } from "./LimitedTimeRulePopup.vue?vue&type=template&id=df67fab2&scoped=true&"
import script from "./LimitedTimeRulePopup.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeRulePopup.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeRulePopup.vue?vue&type=style&index=0&id=df67fab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df67fab2",
  null
  
)

export default component.exports